import * as StoryletActionTypes from 'actiontypes/storylet';

const chooseBranchRequest = () => ({
  type: StoryletActionTypes.CHOOSE_BRANCH_REQUESTED,
});

export default chooseBranchRequest;